__turbopack_context__.v({
  "container": "component-module-scss-module__z6eflW__container",
  "content": "component-module-scss-module__z6eflW__content",
  "countdown": "component-module-scss-module__z6eflW__countdown",
  "label": "component-module-scss-module__z6eflW__label",
  "submit": "component-module-scss-module__z6eflW__submit",
  "validation": "component-module-scss-module__z6eflW__validation",
});
